import {
	CreateOnlineCourseV2DTO,
	LessonDTO,
	OnlineCourseDTO,
	OnlineCourseStatus,
	OrderByEnum,
	RequestParams,
	restRepository,
	SaveDraftOnlineCourseDTO,
	SectionDTO,
	UpdateOnlineCourseV2DTO,
	UpdateLessonProgressWithPriorityDTO,
	LessonProgressPriority,
	OnlineCourseWithProgressDTO,
	UserLessonProgressDTO,
} from "@onair/repositories";

export interface GetOnlineCourseInput {
	category?: string;
	orderBy?: string;
	orderField?: string;
	cursor?: string;
	order?: "ASC" | "DESC";
	offset?: number;
	limit?: number;
	filter?: string;
	status?: string;
	progressStatus?: string;
	fromDate?: string;
	toDate?: string;
	userId?: string;
	isAcademy?: boolean;
	isReskill?: boolean;
	isLaunchpad?: boolean;
	isLnD?: boolean | 1 | 0;
	isOnair?: boolean;
	isFree?: boolean;
	withUpcoming?: boolean;
	planId?: string;
}

export interface GetOnlineCourseV2ListByAdminInput {
	filter?: string;
	cursor?: string;
	order?: OrderByEnum;
	orderField?: string;
	offset?: number;
	limit?: number;
	search?: string;
	isLnD?: boolean;
	isOnair?: boolean;
	status?: OnlineCourseStatus;
	createdFrom?: string;
	createdTo?: string;
}

export interface getListOnlineCourseAndComboCacheInput {
	categories?: string;
	orderField?: string;
	cursor?: string;
	order?: "ASC" | "DESC";
	offset?: number;
	limit?: number;
	filter?: string;
	status?: string;
	fromDate?: string;
	toDate?: string;
	userId?: string;
	isAcademy?: boolean;
}

export const getListOnlineCourse = async (input: GetOnlineCourseInput) => {
	try {
		const response = await restRepository.api.onlineCourseGetList(input);
		return response.data;
	} catch (err) {
		console.log(err);
	}
};

export const getListOnlineCourseAndComboCache = async (
	input: getListOnlineCourseAndComboCacheInput,
) => {
	const fnInput = {
		...input,
		search: input.filter,
	};
	const response =
		await restRepository.api.getOnlineCoursesAndCombosCached(fnInput);
	return response.data;
};

export const getListMyRegisteredOnlineCourse = async (
	input: GetOnlineCourseInput,
) => {
	const response =
		await restRepository.api.onlineCourseGetRegisteredByUser(input);
	return response.data;
};

export const getListOnlineCourseOwnedByHost = async (
	input: GetOnlineCourseInput,
) => {
	const response = await restRepository.api.onlineCourseGetListByHost(input);
	return response.data;
};

export const getListPrivateOnlineCourse = async (
	input: GetOnlineCourseInput,
) => {
	const response = await restRepository.api.onlineCourseGetListPrivate(input);
	// return fakeOnlineCourses.fakeListOnlineCourse(input.limit || 8);
	console.log("response", response.data);
	return response.data;
};

export const getOnlineCourseDetail = async (
	slug: string,
): Promise<OnlineCourseDTO> => {
	const response = await restRepository.api.onlineCourseGetByProductSlug(slug);
	return response.data;
};

export const getDeepOnlineCourseDetail = async (
	slug: string,
): Promise<OnlineCourseDTO> => {
	const response =
		await restRepository.api.onlineCourseGetDeepByProductSlug(slug);
	return response.data;
};
export const getCourseRecommendation = async (
	slug: string,
	isLnD?: boolean,
) => {
	const response = await restRepository.api.onlineCourseGetRecommendations({
		slug,
		...(isLnD !== undefined && { isLnD }),
	});
	return response.data;
};

export const getCourseLessonDetail = async ({
	courseId,
	lessonId,
	sectionId,
}: {
	courseId: string;
	lessonId: string;
	sectionId: string;
}): Promise<LessonDTO> => {
	try {
		const response = await restRepository.api.onlineCourseGetLessionById(
			courseId,
			sectionId,
			lessonId,
		);

		return response.data;
	} catch (error) {
		console.error(error);
		return null;
	}
};

export const getCourseSectionDetail = async ({
	courseId,
	sectionId,
}: {
	courseId: string;
	sectionId: string;
}): Promise<SectionDTO> => {
	try {
		const response = await restRepository.api.onlineCourseGetSectionById(
			courseId,
			sectionId,
		);

		return response.data;
	} catch (error) {
		console.error(error);

		return null;
	}
};

export const getCourseRegisteredUsers = async (
	courseId: string,
	params: { take?: number; skip?: number; search: string },
) => {
	const response = await restRepository.api.onlineCourseGetRegisteredUsers(
		courseId,
		{
			take: params.take || 10,
			skip: params.skip || 0,
			search: params.search,
		},
	);
	return response.data;
};

export const getCourseRegisteredSubscriptionUsers = async (
	courseId: string,
	params: { take?: number; skip?: number; search: string },
) => {
	const response =
		await restRepository.api.onlineCourseGetRegisteredSubscriptionUsers(
			courseId,
			{
				take: params.take || 10,
				skip: params.skip || 0,
				search: params.search,
			},
		);
	return response.data;
};

export const getOnlineCourseDetailById = async (
	slug: string,
): Promise<OnlineCourseDTO> => {
	const response = await restRepository.api.onlineCourseGetById(slug);
	return response.data;
};

export const getPreviewLessonsByCourseId = async (
	courseId: string,
): Promise<LessonDTO[]> => {
	const response =
		await restRepository.api.onlineCourseGetPreviewLessons(courseId);
	return response.data;
};

export interface OnlineCourseComboQueryFilter {
	filter?: string;
	cursor?: string;
	order?: OrderByEnum;
	orderField?: string;
	offset?: number;
	limit?: number;
	category?: string;
	orderBy?: string;
	categories?: string;
	search?: string;
	status?:
	| "DRAFT"
	| "UNPUBLISHED"
	| "REVIEWED"
	| "PUBLISHED"
	| "REJECTED"
	| "DELETED"
	| "PENDING_APPROVAL_WITH_ADMIN";
	fromDate?: string;
	toDate?: string;
	userId?: string;
	isAcademy?: boolean;
}

export const getOnlineCoursesAndCombos = async (
	query?: OnlineCourseComboQueryFilter,
) => {
	const response = await restRepository.api.onlineCourseAndComboGetList(query);
	return response.data;
};

export const getOnlineCoursesAndCombosCached = async (
	query?: OnlineCourseComboQueryFilter,
) => {
	const response =
		await restRepository.api.getOnlineCoursesAndCombosCached(query);
	return response.data;
};

export const exportOnlineCourses = async (filters?: any) => {
	const response = await restRepository.api.adminExportOnlineCourses(filters, {
		format: "blob",
		headers: {
			Accept:
				"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		},
	});

	const blob = (response.data ?? response) as any;
	const url = window.URL.createObjectURL(blob);
	const link = document.createElement("a");
	link.href = url;
	link.setAttribute("download", `online-courses-${Date.now()}.xlsx`);
	document.body.appendChild(link);
	link.click();
	link.remove();
	window.URL.revokeObjectURL(url);
	return true;
};

export const exportOnlineCourseProgress = async (
	filters?: Record<string, unknown>,
) => {
	const response = await restRepository.api.adminExportOnlineCourseProgress(filters,
		{
			format: "blob",
			headers: {
				Accept:
					"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			},
		},
	);

	const blob = (response.data ?? response) as any;
	const url = window.URL.createObjectURL(blob);
	const link = document.createElement("a");
	link.href = url;
	link.setAttribute("download", `online-course-progress-${Date.now()}.xlsx`);
	document.body.appendChild(link);
	link.click();
	link.remove();
	window.URL.revokeObjectURL(url);
	return true;
};

export const createOnlineCourseV2 = async (data: CreateOnlineCourseV2DTO) => {
	return restRepository.api.onlineCourseV2CreateByAdmin(data);
};

export const getOnlineCourseV2Detailed = async (id: string) => {
	const response =
		await restRepository.api.onlineCourseV2GetDetailedByIdByAdmin(id);
	return response.data;
};

export const updateOnlineCourseV2 = async (
	id: string,
	data: UpdateOnlineCourseV2DTO,
) => {
	const updateData = { ...data, id };
	return restRepository.api.onlineCourseV2UpdateByIdByAdmin(id, updateData);
};

export const getOnlineCourseV2ListByAdmin = async (
	input: GetOnlineCourseV2ListByAdminInput,
) => {
	const response = await restRepository.api.onlineCourseV2GetListByAdmin(input);
	return response.data;
};

export const deleteOnlineCourseV2ByAdmin = async (courseId: string) => {
	const response =
		await restRepository.api.onlineCourseV2DeleteByIdByAdmin(courseId);
	return response.data;
};

export const saveOnlineCourseV2Draft = async (
	data: SaveDraftOnlineCourseDTO,
) => {
	const response =
		await restRepository.api.onlineCourseV2SaveDraftByAdmin(data);
	return response.data;
};

export const enableLnDCourse = async (courseId: string) => {
	const response = await restRepository.api.adminLnDEnableCourse(courseId);
	return response.data;
};

export interface GetOnlineCourseLnDQuery {
	categories?: string;
	orderField?: string;
	cursor?: string;
	order?: OrderByEnum;
	offset?: number;
	limit?: number;
	filter?: string;
	status?: OnlineCourseStatus;
	fromDate?: string;
	toDate?: string;
	userId?: string;
	isAcademy?: boolean;
	search?: string;
}

export const getOnlineCousesLnD = async (
	query: GetOnlineCourseLnDQuery = {},
	params?: RequestParams,
) => {
	try {
		const response = await restRepository.api.lndCoursesGetList(query, params);
		return response?.data;
	} catch (err) {
		console.log(err);
	}
};

export interface BufferLessonProgressInput {
	lessonId: string;
	currentPosition: number;
	priority?: LessonProgressPriority;
}

export const bufferLessonProgress = async (
	input: BufferLessonProgressInput,
) => {
	const {
		lessonId,
		currentPosition,
		priority = LessonProgressPriority.Normal,
	} = input;

	const requestBody: UpdateLessonProgressWithPriorityDTO = {
		currentPosition,
		priority,
	};

	const response = await restRepository.api.bufferLessonProgress(
		lessonId,
		requestBody,
	);

	return response.data;
};

export const getCourseWithProgress = async (
	slug: string,
): Promise<OnlineCourseWithProgressDTO> => {
	const response = await restRepository.api.getCourseWithProgress(slug);
	return response.data;
};

export const getLessonProgress = async (
	lessonId: string,
): Promise<UserLessonProgressDTO> => {
	const response = await restRepository.api.getLessonProgress(lessonId);
	return response.data;
};

export const markLessonCompleted = async (
	lessonId: string,
): Promise<UserLessonProgressDTO> => {
	const response = await restRepository.api.markLessonCompleted(lessonId);
	return response.data;
};
